import { combineReducers } from 'redux'

import { authentication } from './authentication.reducer'
import { users } from './users.reducer'
import { alert } from './alert.reducer'
import { banks, search_customer, user_yaa_profile } from './globals.reducer'
import { customers_book, customer_info } from './customers.reducer'

const rootReducer = combineReducers({
	authentication,
	users,
	alert,
	banks,
	search_customer,
	customers_book,
	customer_info,
	user_yaa_profile,
})

export default rootReducer
